<template>
  <div>
    <!-- <session-list v-show="tabType === 1" @handleShow="handleShow" /> -->
    <session-record v-if="tabType === 2" :rowItem="rowItem" />
  </div>
</template>

<script>
import sessionList from './list.vue'
import sessionRecord from './record.vue'
export default {
  components: { sessionList, sessionRecord },
  data() {
    return {
      tabType: 2,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>